import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder"]

  preview(event) {
    const [file] = event.target.files
    if (!file) return

    this.showPreview(file)
  }

  dragOver(event) {
    event.preventDefault()
    this.element.classList.add("border-blue-500", "bg-blue-50/40")
  }

  dragLeave(event) {
    if (this.element.contains(event.relatedTarget)) return
    event.preventDefault()
    this.element.classList.remove("border-blue-500", "bg-blue-50/40")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("border-blue-500", "bg-blue-50/40")

    const [file] = event.dataTransfer?.files ?? []
    if (!file || !file.type.startsWith("image/")) return

    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.inputTarget.files = transfer.files

    this.showPreview(file)
  }

  showPreview(file) {
    const url = URL.createObjectURL(file)
    this.previewTarget.src = url
    this.previewTarget.classList.remove("hidden")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
  }
}
